<template>
  <div class="topo w-100 ui-image--cover" :style="'background-image: url('+require('../../assets/img/topo_blog.jpg')+')'">
    <div class="container h-100">
      <div class="row h-100 justify-content-between align-items-center">
        <div class="col-md-6 col-12">
          <h1 class="ui-title ui-title--intern ui-title--white ui-title--uppercase text-left banner__titulo">
            <b>Empreendimentos</b><br><span v-if="deliveredSelected == 1">entregues</span>
            <span v-if="for_saleSelected == 1">à venda</span>
          </h1>
        </div>
        <div class="col-xl-5 col-lg-5 col-md-6 col-12" v-if="deliveredSelected != 1">
          <div class="empreendimentos__filter">
            <img src="../../assets/img/icon-filter.png" alt="Filtro"> Filtre os empreendimentos
          </div>
          <div :class="{'empreendimentos__filter--item-active': item.id == filterSelected}" class="empreendimentos__filter--item" v-for="(item,index) in empreendimentosFiltros" :key="index">
            <router-link :to="{name: 'Empreendimentos', query: parametros(item.id)}">
              <img v-if="item.image" :src="item.image" :alt="'Filtro '+item.name"> {{item.name}}
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
import { mapGetters } from 'vuex'
export default {
  data () {
    return {
      deliveredSelected: this.$route.query.delivered ? this.$route.query.delivered : '',
      for_saleSelected: this.$route.query.for_sale ? this.$route.query.for_sale : '',
      filterSelected: this.$route.query.filter ? this.$route.query.filter : ''
    }
  },
  computed: {
    ...mapGetters([
      'empreendimentosFiltros'
    ])
  },
  created () {
    this.$store.dispatch('loadEmpreendimentosFiltros')
  },
  watch: {
    '$route' (to, from) {
      this.deliveredSelected = this.$route.query.delivered ? this.$route.query.delivered : ''
      this.for_saleSelected = this.$route.query.for_sale ? this.$route.query.for_sale : ''
      this.filterSelected = this.$route.query.filter ? this.$route.query.filter : ''
    }
  },
  methods: {
    parametros (filter) {
      let parametros = {}
      if (filter) {
        parametros.filter = filter
      }
      if (this.$route.query.category) {
        parametros.category = this.$route.query.category
      }
      if (this.$route.query.delivered) {
        parametros.delivered = this.$route.query.delivered
      }
      if (this.$route.query.for_sale) {
        parametros.for_sale = this.$route.query.for_sale
      }
      return parametros
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../../assets/scss/_variables.scss';
.topo {
  height: 70vh;
  padding-top: 100px;
  @media (max-width: 1600px) {
    height: 60vh;
  }
  @media (max-width: 1400px) {
    height: 65vh;
  }
  @media (max-width: 500px){
    height: 60vh;
    .ui-title--intern {
      text-align: center!important;
    }
  }
  .empreendimentos__filter {
     color: $green;
    font-size: 24px;
    font-weight: 900;
    margin-bottom: 50px;
    img {
      margin-right: 10px;
      margin-top: -5px;
    }
  }
  .empreendimentos__filter--item-active {
    a {
      font-style: inherit;
      font-weight: bold;
      opacity: 1!important;
      transition: all 0.3s;
    }
  }
  .empreendimentos__filter--item {
    margin-bottom: 30px;
    a {
      color: white;
      font-size: 18px;
      font-style: italic;
      opacity: 0.5;
      text-transform: uppercase;
      transition: all 0.3s;
      &:hover {
        font-style: inherit;
        font-weight: bold;
        opacity: 1;
        transition: all 0.3s;
      }
      img {
        margin-right: 10px;
        margin-top: -15px;
      }
    }
  }
  @media (max-width: 991px){
    .empreendimentos__filter {
      font-size: 20px;
      font-weight: 700;
      margin-bottom: 30px;
    }
  }
  @media (max-width: 767px){
    .empreendimentos__filter {
      margin-top: 10px;
      margin-bottom: 15px;
    }
    .empreendimentos__filter--item {
      margin-bottom: 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/empreendimentos/EmpreendimentosBanner.vue